<app-resource-form-card
  [title]="service.title()"
  [resource]="service.resource"
  [createButton]="access()?.user?.actions?.create"
  [detailed]="detailed()"
  [list]="true"
  [user]="true">
  <p-table
    [value]="value()"
    [paginator]="true"
    [rows]="5"
    [rowsPerPageOptions]="[5, 10, 20]"
    [scrollable]="true"
    scrollHeight="flex"
    (onPage)="name($event)"
    >
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th pSortableColumn="username" class="min-w-52">
          Nombre de Usuario <p-sortIcon field="username" />
        </th>
        @if (detailed()) {
          <th pSortableColumn="email" class="min-w-52">
            Correo Electronico <p-sortIcon field="email" />
          </th>
          @if (profile()?.user_type?.access) {
            <th pSortableColumn="description" class="min-w-52">
              Descripcion <p-sortIcon field="description" />
            </th>
          }
          @if (access()?.user_type?.actions?.read) {
            <th pSortableColumn="user_type.name" class="min-w-52">
              Tipo de Usuario <p-sortIcon field="user_type.name" />
            </th>
          }
          @if (access()?.contract?.actions?.read) {
            <th pSortableColumn="contract.name" class="min-w-32">
              Contrato <p-sortIcon field="contract.name" />
            </th>
          }
          @if (access()?.role?.actions?.read) {
            <th pSortableColumn="role.name" class="min-w-32">
              Rol <p-sortIcon field="role.name" />
            </th>
          }
          @if (access()?.branch?.actions?.read) {
            <th pSortableColumn="branch.name" class="min-w-32">
              Sucursal <p-sortIcon field="branch.name" />
            </th>
          }
        }
        <th class="action">
          Acciones
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-value>
      <tr>
        <td class="max-w-min">{{ value.username }}</td>
        @if (detailed()) {
          <td>{{ value.email }}</td>
          @if (profile()?.user_type?.access) {
            <td>{{ value.description ?? 'El usuario no tiene una descripcion' }}</td>
          }
          @if (access()?.user_type?.actions?.read) {
            <td>{{ value.user_type?.name ?? 'El usuario no tiene un tipo de usuario asignado' }}</td>
          }
          @if (access()?.contract?.actions?.read) {
            <td>{{ value.contract?.name ?? 'El usuario no tiene un contrato asignado' }}</td>
          }
          @if (access()?.role?.actions?.read) {
            <td>{{ value.role?.name ?? 'El usuario no tiene un rol asignado' }}</td>
          }
          @if (access()?.branch?.actions?.read) {
            <td>{{ value.branch?.name ?? 'El usuario no tiene una sucursal asignado' }}</td>
          }
        }
        <td>
          <app-resource-button-group
            [resource]="service.resource"
            [resourceId]="value._id"
            [user]="true"
            [iconOnly]="true"
            [detailsButton]="true"
            [editButton]="access()?.user?.actions?.update"
            [deleteButton]="access()?.user?.actions?.delete">
          </app-resource-button-group>
        </td>
      </tr>
    </ng-template>
  </p-table>
</app-resource-form-card>
